import { Injectable } from "@angular/core";
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { SharedService } from "../../../shared/sharedServices/shared.service";
import { decrypt } from "../../../utilities/utilityFunctions";

@Injectable({
	providedIn: "root",
})
export class PcdControllerGuard implements CanActivate {
	constructor(
		public myRoute: Router,
		private sharedServices: SharedService
	) {}
	canActivate(): boolean {
		if (localStorage.getItem("esp-profile-details")) {
			let d = JSON.parse(
				decrypt(localStorage.getItem("esp-profile-details"))
			);
		if (d.profileId && d.getSpRole) {
			for (let i = 0; i < d.getSpRole.length; i++) {
				const processAcronym = d.getSpRole[i].processAcronym || d.getSpRole[i][0];
				const roleValue = d.getSpRole[i].role || d.getSpRole[i][1];
				
				if (
					processAcronym == "PCD" &&
					roleValue == "PCD_UNI_CONTROLLER"
				) {
					return true;
				}
			}
		}
			return false;
		} else {
			// localStorage.clear();
			localStorage.removeItem("esp-profile-details");
			localStorage.removeItem("login");
			localStorage.removeItem("ng2Idle.main.expiry");
			localStorage.removeItem("eduHistory");
			localStorage.removeItem("dob");
			localStorage.removeItem("loginDetails");
			localStorage.removeItem("addresses");
			localStorage.removeItem("primaryNationality");
			localStorage.removeItem("name");
			localStorage.removeItem("Avatar");
			localStorage.removeItem("isForeign");
			document.cookie = "profile=; _ga=0; path=/";
			this.myRoute.navigate(["auth/login"]);
			return false;
		}
	}
}
